import script from "./ProgressViewColumnsSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressViewColumnsSelect.vue?vue&type=script&setup=true&lang=js"

import "./ProgressViewColumnsSelect.vue?vue&type=style&index=0&id=8a256506&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a256506"]])

export default __exports__